import { startDateBeet } from '@metaplex-foundation/mpl-candy-guard';
import { mapSerializer, createSerializerFromBeet } from '../../../types/Serializer.mjs';
import { toDateTime } from '../../../types/DateTime.mjs';

/**
 * The startDate guard determines the start date of the mint.
 * Before this date, minting is not allowed.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const startDateGuardManifest = {
  name: 'startDate',
  settingsBytes: 8,
  settingsSerializer: mapSerializer(createSerializerFromBeet(startDateBeet), settings => ({
    date: toDateTime(settings.date)
  }), settings => settings)
};

export { startDateGuardManifest };
//# sourceMappingURL=startDate.mjs.map
